import { useQuery, useQueryClient } from '@tanstack/react-query';
import { zMeResp, type MeResp } from '@postmaker/shared';
import { api, fijarAccessToken, olvidarSesion, renovarSesion } from './api.ts';

export const CLAVE_SESION = ['sesion'] as const;

/** Al arrancar no hay access token en memoria: se intenta renovar con la cookie. */
async function cargarSesion(): Promise<MeResp | null> {
  const renovado = await renovarSesion();
  if (!renovado) return null;
  return api<MeResp>('/auth/me', { schema: zMeResp });
}

export function useSesion() {
  return useQuery({
    queryKey: CLAVE_SESION,
    queryFn: cargarSesion,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
}

export function useCerrarSesion() {
  const qc = useQueryClient();
  return async () => {
    try {
      await api('/auth/logout', { metodo: 'POST' });
    } finally {
      olvidarSesion();
      qc.setQueryData(CLAVE_SESION, null);
      await qc.invalidateQueries();
    }
  };
}

export { fijarAccessToken };
